export const DEFAULT_CRYPT_SALT = 'crypt';

export const LOB = 'rails';
export const LOB_CATEGORY = 'rails';
export const PAGE_TYPE_FUNNEL = 'funnel';
export const CURRENCY = 'INR';
export const SKU_TYPE_REGULAR = 'Regular Train';
export const CATALOG_SOURCE = 'landing';
export const STORE_ID = 'MMT';
export const ORGANISATION = 'MMT';
export const BU = 'ground_transport';
export const TIMEZONE = 'IST';
export const COUNTRY = 'India';
export const COUNTRY_CODE = 'IN';
export const LOCUS_TYPE = 'CITY';

export const INFANT_MAX_AGE = 4;
export const CHILD_MAX_AGE = 12;

export const TRAVELLER_TYPE = {
  TRAVELLER: 'traveller',
  TRAVELLER_INFO: 'travellerInfo',
};

export const RESERVATION_TYPES = {
  HALF_TICKET_NO_BERTH: 'Half ticket (no berth)',
  FULL_TICKET_FULL_BERTH: 'Full ticket (full berth)',
  GENERAL: 'general',
};

export const GENDER_TITLE_MAP = {
  M: 'Mr',
  F: 'Mrs',
};

export const EVENT_NAMES = {
  PAGE_RENDERED: 'page-rendered',
  BUTTON_CLICKED: 'button-clicked',
};

export const EVENT_TYPES = {
  PAGE: 'page',
  ACTION: 'action',
  USER_INTERACTION: 'user_interaction',
};

export const PAGE_NAMES = {
  REVIEW: 'review',
  TRAVELLERS: 'travellers',
  THANKYOU: 'thankyou',
};

export const COMPONENT_IDS = {
  TRAVELLER_PAGE: 'traveller_page_component',
  REVIEW_PAGE: 'review_page_component',
  THANKYOU_LOAD: 'thankyou_load',
  THANKYOU_PAGE: 'thank_you_page',
};

export const THANK_YOU_EVENT_VALUES = {
  SUCCESS: 'thankyou_load_success',
  FAILURE: 'thankyou_load_failure',
  PENDING: 'thankyou_load_pending',
};

export const ADDON_TYPES = {
  FC: 'FC',
  TG: 'TG',
  COUPON: 'COUPON',
};

export const BOOKING_STATUSES = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};